var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-0 background--paper divider--container"},[_c('div',{staticClass:"divider-white--top"}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"divider-white--bottom"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }